<template>
  <section class="col-12 item-header">
    <div class="row">
      <div class="col-xl-3 col-lg-3 box-col-3">
        <div class="card">
          <div class="card-body user-header">
            <div>
              <img
                width="150px"
                height="150px"
                style="border-radius:50%;object-fit: contain;"
                class="user-img mb-4"
                :src="logo"
                alt=""
              />
              <h4 class="mb-4">{{ user.fullname }}</h4>
              <h5 class="mb-4">{{ user.email }}</h5>
              <h5 class="mb-4">{{ user.phone_number }}</h5>
            </div>
          </div>
        </div>
      </div>

      <div class="col-xl-9 col-lg-9 box-col-9">
        <div class="card item-basic-information">
          <div class="card-header d-flex">
            <div style="flex:1;">
              {{ $t('informasi_dasar') }}
            </div>
            <div class="text-right" style="flex:1;">
              <a v-b-modal.modal-3 class="text-right" >Edit</a>
            </div>

          </div>

          <div class="card-body">
            <div class="row w-full" style="width:100%;">
                <div class="col-md-5  border-split">
                  <div class="item-personal">
                    <div class="d-flex item mb-3">
                      <h3>{{ $t('tanggal_lahir') }}</h3>
                      <h5>{{ basic_info.dob }}</h5>
                    </div>

                    <div class="d-flex item mb-3">
                      <h3>{{ $t('jenis_kelamin') }}</h3>
                      <h5>{{ basic_info.gender }}</h5>
                    </div>

                    <div class="d-flex item mb-3">
                      <h3>Marital Status</h3>
                      <h5>{{ basic_info.marital_status }}</h5>
                    </div>
                  </div>

                </div>
                <div class="col-md-7 border-split">

              <div class="item-address">
                <div class="d-flex">
                  <div style="flex: 0 0 40%">
                    <div class="d-flex item mb-3">
                      <h3>{{ $t('provinsi') }}</h3>
                      <h5>{{ basic_info.provinsi }}</h5>
                    </div>

                    <div class="d-flex item mb-3">
                      <h3>{{ $t('kota_kabupaten') }}</h3>
                      <h5>{{ basic_info.kokab }}</h5>
                    </div>

                  </div>

                  <div style="flex: 0 0 60%">
                    <div class="d-flex item mb-3">
                      <h3>{{ $t('alamat') }}</h3>
                      <h5>{{ basic_info.address }}</h5>
                    </div>
                  </div>
                </div>
              </div>
                </div>
                <!-- <div class="col-md-3">


              <div class="item-minat">
                <div class="item-hobie">
                  <h3>{{ $t('hobi') }}</h3>
                  <div class="list-item">
                    <div
                      v-for="(item, idx) in hobies"
                      :key="idx"
                      class="rounded"
                    >
                      {{ item.name }}
                    </div>
                  </div>
                </div>

                <div class="item-hobie">
                  <h3>{{ $t('keahlian_bahasa') }}</h3>
                  <div class="list-item">
                    <div
                      v-for="(item, idx) in language_skill"
                      :key="idx"
                      class="rounded"
                    >
                      {{ item.name }}
                    </div>
                  </div>
                </div>
              </div>
                </div> -->
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Vertically centered Modal Component -->
    <b-modal
      id="modal-3"
      size="lg"
      width="100%"
      centered
      title="Add Basic Information"
      ok-title="Save"
      @ok="handleSubmit"
      cancel-title="Cancel"
      class="theme-modal"
    >
      <div class="row">

        <div class="col-md-4 col-sm-6">
          <div class="form-group">
            <h6 class="form-label">{{ $t('negara_kelahiran') }}</h6>

            <multiselect
              v-model="form.country"
              :options="dataSource.nations"
              :searchable="true"
              label="name"
              trackBy="name"
              :close-on-select="true"
              :show-labels="true"
              :placeholder="$t('negara')"
            ></multiselect>
          </div>
        </div>
        <div class="col-sm-6 col-md-4">
          <div class="form-group">
            <h6 class="form-label">{{ $t('provinsi') }}</h6>

            <input
              class="form-control"
              v-model="form.provinces"
              :placeholder="$t('provinsi')"
            />
          </div>
        </div>
         <div class="col-sm-6 col-md-4">
          <div class="form-group">
            <h6 class="form-label">{{ $t('tanggal_lahir') }}</h6>
            <datepicker input-class="datepicker-here form-control digits" v-model="dobData" :format="'dd/MM/yyyy'" ></datepicker>
          </div>
        </div>
        <div class="col-sm-6 col-md-6">
          <div class="form-group">
            <h6 class="form-label">{{ $t('jenis_kelamin') }}</h6>

            <multiselect
              v-model="form.gender"
              :options="dataSource.gender"
              :searchable="true"
              label="name"
              :close-on-select="true"
              :show-labels="true"
              :placeholder="$t('jenis_kelamin')"
            ></multiselect>
          </div>
        </div>
        <div class="col-sm-6 col-md-6">
          <div class="form-group">
            <h6 class="form-label">Marital Status</h6>

            <multiselect
              v-model="form.status_marital"
              :options="dataSource.marital"
              :searchable="true"
              label="name"
              :close-on-select="true"
              :show-labels="true"
              placeholder="Pilih Marital Status"
            ></multiselect>
          </div>
        </div>
        <!-- <div class="col-sm-12 col-md-12">
          <div class="form-group">
            <h6 class="form-label">{{ $t('no_ktp') }}</h6>
            <input v-model="form.id_identity" class="form-control" type="text" :placeholder="$t('no_ktp')" />
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <h6 class="form-label">{{ $t('nomor_hp_saat_ini') }}</h6>
            <input
              v-model="form.phone_number"
              class="form-control"
              type="text"
              :placeholder="$t('nomor_hp_saat_ini')"
            />
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <h6 class="form-label">{{ $t('nomor_hp_adisional') }}</h6>
            <input
              v-model="form.additional_phone_number"
              class="form-control"
              type="text"
              :placeholder="$t('nomor_hp_adisional')"
            />
          </div>
        </div> -->
        <div class="col-sm-6 col-md-4">
          <div class="form-group">
            <h6 class="form-label">{{ $t('negara') }}</h6>

            <multiselect
              v-model="form.country_address"
              :options="dataSource.nations"
              :searchable="true"
              label="name"
              :close-on-select="true"
              :show-labels="true"
              :placeholder="$t('negara')"
            ></multiselect>
          </div>
        </div>
        <div class="col-sm-6 col-md-4">
          <div class="form-group">
            <h6 class="form-label">{{ $t('provinsi') }}</h6>

            <input
              class="form-control"
              v-model="form.province_address"
              :placeholder="$t('provinsi')"
            />

            
          </div>
        </div>
        <div class="col-sm-6 col-md-4">
          <div class="form-group">
            <h6 class="form-label">{{ $t('kota_kabupaten') }}</h6>
             <input
              class="form-control"
              v-model="form.regencies_address"
              :placeholder="$t('kota_kabupaten')"
            />
          </div>
        </div>
        <div class="col-md-12">
          <div class="form-group mb-0">
            <h6 class="form-label">{{ $t('alamat') }}</h6>
            <textarea
              class="form-control"
              rows="4"
              v-model="form.address"
              :placeholder="$t('alamat')"
            ></textarea>
          </div>
        </div>

        <!-- <div class="col-md-12 mt-4">
          <div class="form-group mb-0">
            <h6 class="form-label">{{ $t('keahlian_bahasa') }}</h6>
            <multiselect
              v-model="language_selected"
              :options="dataSource.nations"
              :searchable="true"
              label="name"
              :close-on-select="true"
              :show-labels="true"
              :placeholder="$t('keahlian_bahasa')"
              class="mb-2"
            ></multiselect>

            <multiselect
              v-if="language_selected"
              v-model="level_selected"
              :options="dataSource.level_language"
              :searchable="true"
              label="name"
              :close-on-select="true"
              :show-labels="true"
              placeholder="Level"
              @input="addMoreLanguage"
              class="mb-4"
            ></multiselect>


          </div>
        </div>
        <div class="col-md-12 mb-3" v-if="form.language_skill.length > 0">
          <div class="form-group mb-0">
            <h6 class="form-label">{{ $t('keahlian_bahasa_ditambahkan') }}</h6>
            <div>
              <div class="d-flex list-lang">
                <div v-for="(item,idx) in form.language_skill" :key="idx" class="d-flex w-100 mb-2">
                  <div class="number">
                    {{ idx + 1 }}
                  </div>
                  <div class="name">
                    {{ item.language }}
                  </div>

                  <div class="level">
                    {{ item.level.name }}
                  </div>

                  <div class="action">
                    <a href="#" @click="deleteLanguage(idx)" class="btn link"><i class="fa fa-times" aria-hidden="true"></i></a>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-sm-12 col-md-12">
          <div class="form-group">
            <h6 class="form-label">{{ $t('hobi') }}</h6>
            <b-form-tags v-model="form.hobi" placeholder="Hobie"></b-form-tags>
          </div>
        </div> -->

      </div>
    </b-modal>
  </section>
</template>

<script>
  import Multiselect from 'vue-multiselect';
  import Datepicker from 'vuejs-datepicker';
  import { formatDate } from '../../_helpers';
  import { getDataNations,getDataProvinces,getDataRegencies } from "../../_services/data.service";
  import { getDataBasicInformation,submitDataBasicInformation } from "../../_services/profile.service";

  export default {
    components: {
      Multiselect,
      Datepicker
    },
    data() {
      return {
        user: JSON.parse(localStorage.getItem("user")),
        logo: localStorage.getItem('logo'),
        basic_info: {
          dob: "-",
          gender: "-",
          marital_status: "-",
          provinsi: "-",
          kokab: "-",
          kecamatan: "-",
          address:
            "-",
        },
        hobies: ["Menulis", "Membaca"],
        language_skill: ["Indonesia", "English"],
        language_selected: '',
        level_selected: '',
        dataSource : {
          nations: [],
          provinces: [],
          regencies: [],
          gender: [
            {
              name : 'Laki - Laki'
            },
            {
              name: 'Perempuan'
            }
          ],
          marital : [
            {
              name : 'Sudah Menikah'
            },
            {
              name : 'Belum Menikah'
            },
            {
              name : 'Bercerai'
            }
          ],
          level_language : [
            {
              name : 'Pemula',
              value: 1
            },
            {
              name : 'Menengah',
              value: 2
            },
            {
              name : 'Fasih',
              value: 3
            },
            {
              name : 'Fasih Banget',
              value: 4
            }
          ]
        },
        form : {
          id_user: this.$route.query.id_user,
          id : null,
          country: '',
          provinces: '',
          dob: '',
          gender: '',
          status_marital: '',
          id_identity : '',
          phone_number: '',
          additional_phone_number: '',
          country_address: '',
          province_address: '',
          regencies_address: '',
          address: '',
          language_skill : [],
          hobi: []
        }
      };
    },
    computed:{
      dobData : {
        get(){
          return this.form.dob;
        },
        async set(val){
          this.form.dob = await formatDate(val);
        },
      }
    },
    mounted(){
      this.fetchDataNations();
      this.fetchDataProvinces();
      this.fetchDataBasicInformation();

      let lang = localStorage.getItem('currentLanguage') ?  localStorage.getItem('currentLanguage') : process.env.VUE_APP_LANG;
      if (lang == 'en') {
        this.dataSource = {
          nations: [],
          provinces: [],
          regencies: [],
          gender: [
            {
              name : 'Male'
            },
            {
              name: 'Female'
            }
          ],
          marital : [
            {
              name : 'Married'
            },
            {
              name : 'Not married yet'
            },
            {
              name : 'Divorce'
            }
          ],
          level_language : [
            {
              name : 'Beginner',
              value: 1
            },
            {
              name : 'Intermediate',
              value: 2
            },
            {
              name : 'Fluent',
              value: 3
            },
            {
              name : 'Very fluent',
              value: 4
            }
          ]
        } 
      }
      
    },
    methods:{
      async fetchDataNations(){
        await getDataNations().then(res => {
          this.dataSource.nations = res;
        });
      },
      async fetchDataProvinces(){
        await getDataProvinces().then(res => {
          this.dataSource.provinces = res;
        });
      },
      async fetchDataRegencies(){
        await getDataRegencies(this.form.province_address.id).then(res => {
          this.dataSource.regencies = res;
        });
      },
      async fetchDataBasicInformation(){
        await getDataBasicInformation(this.$route.query.id_user).then(res => {
          if (res) {

            this.basic_info = {
              dob: res.dob_format,
              gender: res.gender,
              marital_status: res.marital_status,
              provinsi: res.prov,
              kokab: res.kokab,
              address: res.address
            };

            this.hobies = res.hobies;
            this.language_skill = res.language_skills;
            // Untuk Form
            this.form = {
              id : res.id,
              country: res.country,
              provinces: res.pob,
              dob: res.dob,
              gender: {
                name : res.gender
              },
              status_marital: {
                name : res.marital_status
              },
              id_identity : res.id_identity,
              phone_number: res.phone_number,
              additional_phone_number: res.additional_phone_number,
              nation: res.pob,
              province_address: res.prov,
              regencies_address: res.kokab,
              address: res.address,
              country_address: res.country,
              language_skill : [],
              hobi: [],
            };

            res.hobies.forEach(el => {
              this.form.hobi.push(el.name);
            });

            res.language_skills.forEach(el => {

              this.dataSource.level_language.forEach(val => {
                if (val.value === el.lavel) {

                  this.form.language_skill.push({
                    language: el.name,
                    level : val
                  });
                }
              });
            });

          }else{
            this.basic_info = {
              dob: '-',
              gender: '-',
              marital_status: '-',
              provinsi: '-',
              kokab: '-',
              kecamatan: '-',
              address: '-'
            };

            this.hobies = [];
            this.language_skill = [];
          }
        });
      },
      async handleSubmit(){
        await submitDataBasicInformation(this.form);
        this.fetchDataBasicInformation();
      },
      addMoreLanguage(){
        this.form.language_skill.push({
          language : this.language_selected.name,
          level : this.level_selected
        });
        this.language_selected = '';
        this.level_selected = '';
      },
      deleteLanguage(idx){
        this.form.language_skill.splice(idx, 1);
      },
    }
  };
</script>

<style lang="scss">
.item-header {
  .item-basic-information {
    .card-header {
      padding: 18px 25px !important;
      font-size: 1.1rem;
      font-weight: 500;
    }
    .item {
      flex-direction: column;
      h3 {
        font-size: 0.8rem;
        font-weight: 500;
      }
      h5 {
        font-size: 0.8rem;
        font-weight: 400;
      }
    }
    .card-body {
      padding: 0;
    }

    .item-personal {
        height: 100%;
        padding: 18px 25px;
    }

    .item-address {
      height: 100%;
        padding: 18px 25px;
    }

    .item-minat {
      height: 100%;
        padding: 18px 25px;
      display: flex;
      flex-direction: column;

      .item-hobie {
        flex: 1;
        h3 {
          font-size: 0.8rem;
          font-weight: 500;
        }

        .list-item {
          display: flex;
          flex-wrap: wrap;
          gap: 5px;
          .rounded {
            padding: 0.2rem 1rem;
            background: var(--theme-deafult);
            color: var(--theme-font);
            font-size: 0.6rem;
            border-radius: 1rem !important;
          }
        }
      }
    }

    .card-body {
      display: flex;
      .d-flex {
        width: 100%;
      }
    }
  }
  .card {
    min-height: 350px;
    height: 350px;
    overflow: auto;
  }
}

.user-header {
  border: 3px solid var(--theme-deafult);
  border-radius: 10px;
  text-align: center;
  padding: 2rem 1rem !important;
  h4 {
    font-weight: 500;
    text-transform: capitalize;
    font-size: 1.1rem;
  }
  h5 {
    font-weight: 400;
    font-size: 0.9rem;
  }
}

.list-lang{
  flex-wrap: wrap;
  .d-flex{
    padding: .3rem 1rem;
    border: 2px solid var(--theme-deafult);
    border-radius: 6px;
  }
  .number{
    -webkit-box-flex: 0;
    flex: 0 0 5%;
    max-width: 5%;
    align-self: center;
    font-weight: 500;
  }

  .name{
      -webkit-box-flex: 0;
    flex: 0 0 40%;
    max-width: 40%;
    align-self: center;
    font-weight: 500;
  }

  .level{
    -webkit-box-flex: 0;
    flex: 0 0 40%;
    max-width: 40%;
    align-self: center;
    font-weight: 500;
  }

  .action{
    -webkit-box-flex: 0;
    flex: 0 0 15%;
    max-width: 15%;
    text-align: right;
    align-self: center;
    font-weight: 500;
  }
}
.basic-info{
  flex-wrap: wrap;
}
</style>



<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>